import InfoIcon from '../icons/InfoIcon';
import ErrorIcon from '../icons/ErrorIcon';
import SuccessIcon from '../icons/SuccessIcon';

export const alertIconsMap = {
  info: InfoIcon,
  error: ErrorIcon,
  success: SuccessIcon,
};

export default alertIconsMap;
